export const COLUMNS_COUNT = 4;
